{
  "profile.avatar.alt": "{name} 的头像",
  "profile.avatar.change": "选择头像",
  "profile.avatar.description": "JPEG、PNG 或 WebP，最大 5 MB。上传后立即更新。",
  "profile.avatar.invalid": "请选择不超过 5 MB 的 JPEG、PNG 或 WebP 图片。",
  "profile.avatar.label": "个人头像",
  "profile.avatar.no_image": "尚未设置头像",
  "profile.avatar.progress": "头像上传进度 {percent}%",
  "profile.avatar.submit": "上传头像",
  "profile.avatar.success": "头像已更新。",
  "profile.avatar.upload_error": "头像上传失败，请重新选择文件后重试。",
  "profile.basic.description": "管理你的个人显示信息、语言和时区偏好。",
  "profile.connections.account_hint": "账号提示：{hint}",
  "profile.connections.action_error": "第三方账号操作失败，请重试。",
  "profile.connections.bind": "绑定账号",
  "profile.connections.bound_at": "绑定时间：{date}",
  "profile.connections.connected": "已绑定",
  "profile.connections.description": "管理当前账号绑定的第三方身份。第三方令牌和原始账号标识不会显示。",
  "profile.connections.empty": "尚未绑定第三方账号。",
  "profile.connections.feature_disabled": "第三方账号绑定当前未启用。",
  "profile.connections.load_error": "无法加载第三方账号，请重试。",
  "profile.connections.not_connected": "未绑定",
  "profile.connections.provider_description": "通过已批准的 OAuth 适配器连接账号。",
  "profile.connections.providers.local": "本地 OAuth 模拟器",
  "profile.connections.unbind": "解绑",
  "profile.connections.unbind_confirm": "该第三方账号将不能再用于当前账号。请确认仍可使用密码或多因素认证登录。",
  "profile.connections.unbind_success": "第三方账号已解绑。",
  "profile.connections.unbind_title": "解绑第三方账号？",
  "profile.devices.active_sessions": "活动会话数",
  "profile.devices.confirm_current": "移除当前设备会撤销此设备的全部会话，并立即退出登录。确定继续吗？",
  "profile.devices.confirm_other": "确定移除此设备吗？该设备的全部会话都会被撤销。",
  "profile.devices.created_at": "首次登记",
  "profile.devices.current": "当前设备",
  "profile.devices.description": "管理与后台账号关联的 Web 设备。移除设备会撤销该设备的全部登录会话。",
  "profile.devices.empty": "没有已登记设备。下次使用支持设备标识的浏览器登录后会自动登记。",
  "profile.devices.ip_address": "最近 IP 地址",
  "profile.devices.last_seen_at": "最近活动",
  "profile.devices.load_error": "无法加载设备列表，请重试。",
  "profile.devices.platform.web": "Web",
  "profile.devices.remove": "移除设备",
  "profile.devices.remove_error": "设备移除失败，请重试。",
  "profile.devices.remove_success": "设备已移除，关联会话已撤销。",
  "profile.devices.remove_title": "确认移除设备",
  "profile.devices.title": "已登记设备",
  "profile.devices.unknown": "未知设备",
  "profile.fields.display_name": "显示名称",
  "profile.fields.email": "登录邮箱",
  "profile.fields.locale": "语言",
  "profile.fields.time_zone": "时区",
  "profile.language.save_error": "未保存，请重试",
  "profile.language.title": "显示语言",
  "profile.load_error": "无法加载个人设置，请重试。",
  "profile.mfa.action_error": "多因素认证操作失败，请检查验证信息后重试。",
  "profile.mfa.authenticator": "身份验证器",
  "profile.mfa.code_invalid": "请输入身份验证器生成的 6 位验证码。",
  "profile.mfa.code_label": "6 位验证码",
  "profile.mfa.description": "使用身份验证器和一次性恢复码加强当前账号安全。",
  "profile.mfa.disable": "停用",
  "profile.mfa.disable_success": "多因素认证已停用。",
  "profile.mfa.disable_title": "停用多因素认证",
  "profile.mfa.disabled": "未启用",
  "profile.mfa.enabled": "已启用",
  "profile.mfa.enroll": "设置身份验证器",
  "profile.mfa.enrollment_title": "设置身份验证器",
  "profile.mfa.load_error": "无法加载多因素认证状态，请重试。",
  "profile.mfa.recovery_ack": "我已将恢复码保存到安全位置",
  "profile.mfa.recovery_once": "这些恢复码只显示一次。每个恢复码只能使用一次。",
  "profile.mfa.recovery_remaining": "剩余 {count} 个恢复码",
  "profile.mfa.recovery_title": "一次性恢复码",
  "profile.mfa.rotate_codes": "重新生成恢复码",
  "profile.mfa.rotate_title": "重新生成恢复码",
  "profile.mfa.saved_codes": "我已安全保存",
  "profile.mfa.secret_label": "一次性设置密钥",
  "profile.mfa.secret_once": "密钥和配置地址只显示一次，请勿保存到截图或不安全的位置。",
  "profile.mfa.step_up.password": "当前密码",
  "profile.mfa.step_up.totp": "身份验证器验证码",
  "profile.mfa.step_up_invalid": "请输入有效的验证信息。",
  "profile.mfa.step_up_method": "验证方式",
  "profile.mfa.step_up_notice": "此敏感操作需要再次验证身份。",
  "profile.mfa.step_up_proof": "验证信息",
  "profile.mfa.title": "多因素认证",
  "profile.mfa.verify": "验证并启用",
  "profile.navigation.basic": "基本设置",
  "profile.navigation.connections": "第三方绑定",
  "profile.navigation.security": "安全设置",
  "profile.oauth_callback.error": "无法完成第三方账号绑定",
  "profile.oauth_callback.error_description": "绑定请求无效、已过期或已使用。请返回后重新发起。",
  "profile.oauth_callback.processing": "正在安全完成第三方账号绑定…",
  "profile.oauth_callback.return": "返回第三方绑定",
  "profile.oauth_callback.success": "第三方账号绑定成功",
  "profile.oauth_callback.success_description": "已绑定 {provider}，授权参数已从地址栏移除。",
  "profile.password.confirm": "确认新密码",
  "profile.password.current": "当前密码",
  "profile.password.current_invalid": "当前密码不正确。",
  "profile.password.description": "修改后保留当前会话，并撤销账号的其他后台会话。",
  "profile.password.error": "密码修改失败，请重试。",
  "profile.password.mismatch": "两次输入的新密码不一致。",
  "profile.password.new": "新密码",
  "profile.password.requirements": "使用 12–256 个字符，且不能与当前或最近使用的密码相同。",
  "profile.password.reused": "新密码不能与当前或最近使用的密码相同。",
  "profile.password.submit": "修改密码",
  "profile.password.success": "密码已修改，其他后台会话已撤销。",
  "profile.password.title": "修改密码",
  "profile.save_error": "个人设置保存失败，请重试。",
  "profile.save_success": "个人设置已保存。",
  "profile.security.description": "查看并管理当前账号在后台管理端的活动会话。",
  "profile.sessions.absolute_expires_at": "会话过期",
  "profile.sessions.confirm_current": "撤销当前会话后，你会立即退出登录。确定继续吗？",
  "profile.sessions.confirm_other": "确定撤销此会话吗？该会话将无法继续访问后台。",
  "profile.sessions.created_at": "登录时间",
  "profile.sessions.current": "当前会话",
  "profile.sessions.empty": "没有活动会话。",
  "profile.sessions.ip_address": "IP 地址",
  "profile.sessions.last_seen_at": "最近活动",
  "profile.sessions.load_error": "无法加载活动会话，请重试。",
  "profile.sessions.revoke": "撤销会话",
  "profile.sessions.revoke_error": "会话撤销失败，请重试。",
  "profile.sessions.revoke_success": "会话已撤销。",
  "profile.sessions.revoke_title": "确认撤销会话",
  "profile.sessions.title": "活动会话",
  "profile.sessions.unknown": "未知",
  "profile.sessions.user_agent": "浏览器与设备",
  "profile.staff.binding.title": "绑定移动端员工账号",
  "profile.staff.binding.description": "保留 App 与后台账号。仅通过两端确认建立关联，不按手机号或邮箱自动合并。",
  "profile.staff.binding.unbind_confirm": "解除绑定将停止移动接待并撤销通过此绑定建立的扫码登录会话。是否继续？",
  "profile.staff.binding.unbind": "解除绑定",
  "profile.staff.binding.add": "绑定移动端",
  "profile.staff.binding.hint": "验证员工身份后生成二维码。使用选定 App 扫码确认，再在此确认待绑定账号；二维码两分钟有效。",
  "profile.staff.binding.confirm": "确认绑定此 App 账号",
  "profile.staff.login.title": "App 扫码登录",
  "profile.staff.login.hint": "请打开 AppKernia App 扫一扫，并在 App 内核对网站和员工身份后确认。",
  "profile.staff.error": "操作未完成，请检查权限、安全验证码、二维码状态或网络后重试。",
  "profile.staff.app": "员工移动应用",
  "profile.staff.verification": "安全验证方式",
  "profile.staff.password": "后台登录密码",
  "profile.staff.totp": "身份验证器动态码",
  "profile.staff.proof": "安全验证码或密码",
  "profile.staff.required": "请填写有效值",
  "profile.staff.generate": "生成二维码",
  "profile.staff.state.pending": "等待 App 扫码",
  "profile.staff.state.scanned": "已扫描，等待 App 确认",
  "profile.staff.state.approved": "App 已确认",
  "profile.staff.state.consumed": "操作已完成",
  "profile.staff.state.cancelled": "操作已取消",
  "profile.staff.state.expired": "二维码已过期，请重新生成",
  "profile.staff.errors.step_up": "请使用当前有效的安全验证信息；已启用身份验证器时必须填写动态码。",
  "profile.staff.errors.conflict": "二维码已被使用或绑定关系发生冲突，请检查现有绑定并重新生成二维码。",
  "profile.staff.errors.rate_limit": "操作过于频繁，请稍后重新尝试。",
  "profile.staff.errors.forbidden": "身份、应用权限或浏览器凭据已失效，请重新登录后操作。",
  "profile.staff.not_configured": "尚未配置可绑定的员工 App，请联系部署管理员配置员工 App 白名单。",
  "profile.staff.empty": "尚未绑定移动端账号",
  "profile.staff.refresh": "刷新二维码",
  "profile.staff.account_login": "账号登录",
  "profile.staff.login.description": "使用已绑定的 App 账号扫码并确认登录。"
}
